// store/index.js
import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

const store = createStore({
  state: {
    seatDetails: null,
    bookingDetails: null,
    journeySearch: null,
    paymentData: null,
    currentLanguage: localStorage.getItem("app_lang") || "sw",
    firstVisit: !localStorage.getItem("language_selected"),
    auth: {
      token: localStorage.getItem("auth_token") || null,
      user: JSON.parse(localStorage.getItem("user") || "null"),
      isAuthenticated: !!localStorage.getItem("auth_token"),
    },
  },
  mutations: {
    setLanguange(state, lang) {
      state.currentLanguage = lang;
      localStorage.setItem("app_lang", lang);
    },
    setFirstVisit(state, value) {
      state.firstVisit = value;
    },
    setSeatDetails(state, details) {
      state.seatDetails = details;
    },
    setBookingDetails(state, details) {
      state.bookingDetails = details;
    },
    setJourneySearch(state, search) {
      state.journeySearch = search;
    },
    setPaymentData(state, data) {
      state.paymentData = data;
    },
    clearBookingData(state) {
      state.seatDetails = null;
      state.bookingDetails = null;
      state.paymentData = null;
    },
    // Add authentication mutations
    setAuthToken(state, token) {
      state.auth.token = token;
      state.auth.isAuthenticated = true;
      localStorage.setItem("auth_token", token);
    },
    setUserData(state, user) {
      state.auth.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
    clearAuthData(state) {
      state.auth.token = null;
      state.auth.user = null;
      state.auth.isAuthenticated = false;
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user");
    },
  },
  actions: {
    changeLanguage({ commit }, lang) {
      commit("setLanguange", lang);
      commit("setFirstVisit", false);
      localStorage.setItem("language_selected", "true");
    },
    updateSeatDetails({ commit }, details) {
      commit("setSeatDetails", details);
    },
    updateBookingDetails({ commit }, details) {
      commit("setBookingDetails", details);
    },
    updateJourneySearch({ commit }, search) {
      commit("setJourneySearch", search);
    },
    updatePaymentData({ commit }, data) {
      commit("setPaymentData", data);
    },
    clearBookingData({ commit }) {
      commit("clearBookingData");
    },
    // Add authentication actions
    login({ commit }, { token, user }) {
      commit("setAuthToken", token);
      commit("setUserData", user);
    },
    logout({ commit }) {
      commit("clearAuthData");
    },
  },
  getters: {
    seatDetails: (state) => state.seatDetails,
    bookingDetails: (state) => state.bookingDetails,
    journeySearch: (state) => state.journeySearch,
    paymentData: (state) => state.paymentData,
    // Add authentication getters
    isAuthenticated: (state) => state.auth.isAuthenticated,
    currentUser: (state) => state.auth.user,
    authToken: (state) => state.auth.token,
  },
  plugins: [
    createPersistedState({
      storage: localStorage,
    }),
  ],
});

export default store;
